import { useLocation, Navigate, Outlet } from "react-router-dom"
import { useSelector } from "react-redux"
import { selectCurrentUser } from "./authSlice"

const RequireAdmin = () => {
    const user = useSelector(selectCurrentUser)
    const location = useLocation()

    const isAdmin = user?.is_staff || user?.is_superuser || user?.is_contractor_admin

    return (
        isAdmin
            ? <Outlet />
            : <Navigate to="/" state={{ from: location }} replace />
    )
}
export default RequireAdmin
